import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-outer-link",
  "use": "foquz-icon-outer-link-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" id=\"foquz-icon-outer-link\"><path d=\"M10 8v.8A1.2 1.2 0 018.8 10H2.2A1.2 1.2 0 011 8.8V2.2A1.2 1.2 0 012.2 1H3m4 0h3m0 0v3m0-3L5.5 5.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol